import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { styled } from '@mui/material/styles';

const StyLink = styled(Link, {
    name: 'StyLink',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 'bold',
}));

type LinkCellRendererParams<DataT> = CellRendererParams<DataT, string> & {
    getUrl?: (
        data: DataT | undefined,
        location?: LocationT,
    ) => string | { pathname: string; state: { parentLocation: LocationT } };
    getDisabled?: (data: DataT | undefined) => boolean;
    onClick?: (data: DataT) => void;
    style?: React.CSSProperties;
    target?: string;
};

export default function LinkCellRenderer<DataT = unknown>({
    value,
    data,
    getUrl,
    getDisabled,
    style,
    onClick,
    target,
}: LinkCellRendererParams<DataT>): React.ReactElement | null {
    const location = useLocation();
    // FIXME: this is hack to prevent this kind of bug:
    // https://www.loom.com/share/1bd07d89aace4b1d9242d7c4222de5a7
    // find a proper solution
    if (!data) {
        return null;
    }
    const isDisabled = getDisabled ? getDisabled(data) : false;

    const url = getUrl?.(data, location);
    const pathname = typeof url === 'string' ? url : url?.pathname ?? '';
    const state = typeof url === 'string' ? null : url?.state ?? null;

    return isDisabled || url === undefined ? (
        <>{value}</>
    ) : (
        <StyLink
            to={pathname}
            style={style}
            onClick={() => onClick?.(data)}
            state={state}
            target={target}
        >
            {value}
        </StyLink>
    );
}
